import { ProductKindEnum, isProductKind } from '@iheartjane/types';

import type { FilterSelectItem } from '@jane/search/data-access';
/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';

/**
 * This method accepts filters, with a store's menu tabs arrangement and custom product rankings.
 *
 * If a filter is not a product root type, it means the filter is a row rather than
 * a category, and it shouldn't be rendered with the categories.
 */

export const sortAndFilterCategories = (
  filters: FilterSelectItem[],
  customRanking: Store['custom_product_type_ranking'] = [],
  menuTabs: Store['menu_tabs'] = []
): FilterSelectItem[] => {
  const sortByArray = [
    ...menuTabs,
    ...ProductKindEnum,
    ...(customRanking ?? []),
  ];

  return [...filters]
    .sort((a, b) => {
      const indexA = sortByArray.indexOf(a.value);
      const indexB = sortByArray.indexOf(b.value);

      // Handle case when index is -1 (item not found in sortByArray)
      const effectiveIndexA = indexA !== -1 ? indexA : Infinity;
      const effectiveIndexB = indexB !== -1 ? indexB : Infinity;

      return effectiveIndexA - effectiveIndexB;
    })
    .filter(({ value }) => isProductKind(value));
};
